import Grid from "@mui/material/Unstable_Grid2";
import React, { useCallback } from "react";
import { Button, Box, Link, Modal } from "@mui/material";
import "./Taxation.scss";

import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import DatePicker from "../../../../../../Supporting files/DatePicker/DatePicker";
import NewTaxPopup from "./NewTaxPopup/NewTaxPopup";
import EditTaxPopup from "./EditTaxPopup/EditTaxPopup";
import AddNewTaxGroup from "./AddNewTaxGroup/AddNewTaxGroup";

const Taxation = () => {
  const [legalname, setLegalName] = React.useState("");
  const [tradename, setTradeName] = React.useState("");
  const [regDate, setRegDate] = React.useState<Date | null>(null);
  const [taxPopup, setTaxPopup] = React.useState(false);
  const [edittaxPopup, setEditTaxPopup] = React.useState(false);
  const [newtaxgroup, setNewTaxGroup] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);

  const fields_data = [
    {
      taxname: "Tax 1",
      rate: "3.5",
      taxtype: "VST",
      delete: "images/delete_icon.svg",
      edit: "images/edit_icon.svg",
    },
    {
      taxname: "Tax 2",
      rate: "8",
      taxtype: "GST",
      delete: "images/delete_icon.svg",
      edit: "images/edit_icon.svg",
    },
    {
      taxname: "Tax 3",
      rate: "11.5",
      taxtype: "Surcharge",
      delete: "images/delete_icon.svg",
      edit: "images/edit_icon.svg",
    },
    {
      taxname: "Tax 4",
      rate: "24",
      taxtype: "CESS",
      delete: "images/delete_icon.svg",
      edit: "images/edit_icon.svg",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  return (
    <Box className="taxation_wrapper">
      <NewTaxPopup
        open_status={taxPopup}
        attrName={setTaxPopup}
        value_update={updateMasterState}
      />
      <EditTaxPopup
        open_status={edittaxPopup}
        attrName={setEditTaxPopup}
        value_update={updateMasterState}
      />
      <AddNewTaxGroup
        open_status={newtaxgroup}
        attrName={setNewTaxGroup}
        value_update={updateMasterState}
      />
      <Grid container spacing={2}>
        <Grid xs={8}>
          <h3>Tax Rates</h3>
        </Grid>

        <Grid xs={4} className="text-right">
          <div className="buttons">
            <Link
              underline="none"
              className="blueBtn addfile"
              onClick={() => {
                setTaxPopup(true);
              }}
            >
              New Tax
            </Link>

            <Link
              underline="none"
              className="greenBtn addfile"
              onClick={() => {
                setNewTaxGroup(true);
              }}
            >
              New Tax Group
            </Link>
          </div>
        </Grid>
      </Grid>
      <Box className="detailSection">
        <div className="sectionTitle">
          <h4>Basic Information</h4>
          <div className="actionBtns">
            <Link
              className="blueBtn edit"
              sx={{ textDecoration: "none", cursor: "pointer" }}
              onClick={() => {
                setNewTaxGroup(true);
              }}
            >
              Edit
            </Link>
          </div>
        </div>
        <div className="pl-4">
          <Grid container spacing={3}>
            <Grid xs={12}>
              <p className="tax_id">
                Tax ID: <span> GST897DSVG</span>
              </p>
            </Grid>
          </Grid>
        </div>
        <div className="pl-4 pr-3">
          <Grid container spacing={3}>
            <Grid xs={6} md={4} lg={3}>
              <RKTextField
                class_name="inputField"
                title={"Business Legal Name"}
                value={legalname}
                attrName={setLegalName}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <RKTextField
                class_name="inputField"
                title={"Business Trade Name"}
                value={tradename}
                attrName={setTradeName}
                value_update={updateMasterState}
                warn_status={false}
              />
            </Grid>
            <Grid xs={6} md={4} lg={4}>
              <DatePicker
                class_name="inputField"
                title="Tax ID Registration Date"
                value={regDate}
                attrName={setRegDate}
                value_update={updateMasterState}
                error_message="Please enter reg Date"
                warn_status={false}
              />
            </Grid>
            <Grid xs={6} md={4} lg={2} className="ctaBtn">
              <Button variant="contained" className="submitBtn">
                Save
              </Button>
            </Grid>
          </Grid>
        </div>
      </Box>
      <Grid container spacing={2}>
        <Grid xs={12} className="fieldsBox">
          <ul className="dataHeading">
            <li>Tax Name</li>
            <li>Rate (%)</li>
            <li>Tax Type</li>
            <li>Actions</li>
          </ul>
          {fields_data.map((data, index) => (
            <ul className="dataLists">
              <li>{data.taxname}</li>
              <li>{data.rate}</li>
              <li>{data.taxtype}</li>
              <li>
                <Link
                  sx={{
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setDeleteStatus(true);
                  }}
                >
                  <img src={data.delete} alt="" />
                </Link>
                <Link
                  className="ml-3"
                  sx={{
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setEditTaxPopup(true);
                  }}
                >
                  <img src={data.edit} alt="" />
                </Link>
              </li>
            </ul>
          ))}
        </Grid>
      </Grid>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to Delete this tax.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
};

export default Taxation;
